// @ts-nocheck
/**
 * Capsule outfit "add all" flow: ui-dialog-sheet, per-product variant steps (Liquid + ui-variant-selector), summary, /cart/add.js.
 */
(function () {
  /** Set `sessionStorage.setItem('ob_bundle_debug','1')`, `?ob_debug=1`, or `window.__OB_BUNDLE_DEBUG = true` then reproduce; console shows why Next stayed disabled. */
  function isOutfitBundleDebugEnabled() {
    try {
      if (typeof window !== 'undefined' && window.__OB_BUNDLE_DEBUG) return true;
      if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ob_bundle_debug') === '1') return true;
      if (typeof localStorage !== 'undefined' && localStorage.getItem('ob_bundle_debug') === '1') return true;
      if (typeof URL !== 'undefined' && typeof location !== 'undefined') {
        var sp = new URLSearchParams(location.search || '');
        if (sp.get('ob_debug') === '1') return true;
      }
    } catch (_e) {}
    return false;
  }

  function disconnectOutfitBundleDomObservers(mountEl) {
    if (!mountEl) return;
    if (mountEl._outfitBundleDomObserver) {
      try {
        mountEl._outfitBundleDomObserver.disconnect();
      } catch (_e) {}
      mountEl._outfitBundleDomObserver = null;
    }
  }

  function openDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.classList.remove('ui-dialog-sheet--closing');
    dialog.removeAttribute('data-ui-dialog-closing');
    dialog.showModal();
  }

  function formatMoney(cents, currencyCode) {
    var c = typeof cents === 'number' ? cents : 0;
    var code = currencyCode || 'USD';
    var amount = c / 100;
    try {
      var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: code });
      if (typeof nf.formatToParts !== 'function') {
        return nf.format(amount);
      }
      var parts = nf.formatToParts(amount);
      var frac = parts.find(function (p) {
        return p.type === 'fraction';
      });
      var stripFraction = frac && /^0+$/.test(frac.value);
      var out = stripFraction
        ? parts.filter(function (p) {
            return p.type !== 'decimal' && p.type !== 'fraction';
          })
        : parts;
      return out
        .map(function (p) {
          return p.value;
        })
        .join('');
    } catch (e) {
      return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    }
  }

  function hideSummarySlot(slot) {
    if (!slot) return;
    slot.innerHTML = '';
    slot.removeAttribute('data-ob-summary-json');
    slot.setAttribute('hidden', '');
    slot.classList.add('hidden');
  }

  /** Shopify’s placeholder when a product has no real options — omit in line-item style UIs. */
  function isShopifyDefaultVariantTitle(title) {
    if (title == null) return false;
    return String(title).trim().toLowerCase() === 'default title';
  }

  function variantLineLabelForUi(title) {
    if (title == null || title === '') return '';
    var s = String(title).trim();
    if (isShopifyDefaultVariantTitle(s)) return '';
    return s;
  }

  function setChromeNotice(chromeDynamic, message) {
    if (!chromeDynamic) return;
    var notice = chromeDynamic.querySelector('[data-ob-chrome-notice]');
    if (!message) {
      if (notice) notice.remove();
      return;
    }
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'text-sm text-muted';
      notice.setAttribute('data-ob-chrome-notice', '');
      chromeDynamic.appendChild(notice);
    }
    notice.textContent = message;
  }

  function setProgress(chromeTop, percent) {
    if (!chromeTop) return;
    var progress = chromeTop.querySelector('[data-ob-progress]');
    var fill = chromeTop.querySelector('[data-ob-progress-fill]');
    if (!progress || !fill) return;
    progress.removeAttribute('hidden');
    progress.classList.remove('hidden');
    fill.style.width = String(percent) + '%';
  }

  function setStepLabel(chromeTop, label) {
    if (!chromeTop) return;
    var el = chromeTop.querySelector('[data-ob-step-label]');
    if (!el) return;
    if (!label) {
      el.textContent = '';
      el.setAttribute('hidden', '');
      el.classList.add('hidden');
      return;
    }
    el.textContent = label;
    el.removeAttribute('hidden');
    el.classList.remove('hidden');
  }

  function setStepHint(chromeTop, hint) {
    if (!chromeTop) return;
    var el = chromeTop.querySelector('[data-ob-step-hint]');
    if (!el) return;
    if (!hint) {
      el.textContent = '';
      el.setAttribute('hidden', '');
      el.classList.add('hidden');
      return;
    }
    el.textContent = hint;
    el.removeAttribute('hidden');
    el.classList.remove('hidden');
  }

  function mixinOrdinalAmongSteps(items, productStepIndex) {
    if (!items || productStepIndex == null || productStepIndex < 0) return 0;
    var n = 0;
    for (var i = 0; i <= productStepIndex; i++) {
      if (items[i] && items[i].is_mixin) n++;
    }
    return n;
  }

  /** Mix-in title/hint from `<template>` so `&` is not JSON-escaped or double-entity in data attributes. */
  function readMixinChromeStrings(chromeTop) {
    if (!chromeTop) return { prefix: 'Select mix-in', hint: '' };
    function tplText(tpl) {
      if (!tpl || tpl.tagName !== 'TEMPLATE') return '';
      var c = tpl.content;
      if (c && c.textContent != null) return String(c.textContent).trim();
      return String(tpl.textContent || '').trim();
    }
    var tplTitle = chromeTop.querySelector('template[data-ob-mixin-title-source]');
    var tplHint = chromeTop.querySelector('template[data-ob-mixin-hint-source]');
    var prefix = tplText(tplTitle) || 'Select mix-in';
    var hint = tplText(tplHint);
    return { prefix: prefix, hint: hint };
  }

  function tagOutfitBundleForms(root) {
    if (!root) return;
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.closest('[data-outfit-bundle-mount]')) f.setAttribute('data-cart-drawer-skip', '');
    });
  }

  /** Numeric id for /cart/add.js (Shopify accepts integer variant id). */
  function variantIdForCart(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).trim();
    if (!s) return null;
    var n = parseInt(s, 10);
    return Number.isFinite(n) ? n : null;
  }

  /** Raw string id from the form — matches JSON variant `id` strings without JS float rounding. */
  function getVariantIdFromBundleForm(form) {
    if (!form) return null;
    var checked = form.querySelector('input[name="id"][type="radio"]:checked');
    if (checked && String(checked.value || '').trim() !== '') return String(checked.value).trim();
    var hidden = form.querySelector('input[name="id"][type="hidden"][data-pdp-variant-id-input]');
    if (hidden && String(hidden.value || '').trim() !== '') return String(hidden.value).trim();
    var checkedLoose = form.querySelector('input[name="id"]:checked');
    if (checkedLoose && String(checkedLoose.value || '').trim() !== '') return String(checkedLoose.value).trim();
    var radios = form.querySelectorAll('input[name="id"][type="radio"]');
    for (var ri = 0; ri < radios.length; ri++) {
      var r = radios[ri];
      if (r.checked && !r.disabled && String(r.value || '').trim() !== '') return String(r.value).trim();
    }
    return null;
  }

  function getOrderedStepPanels(stepRoot) {
    var panels = Array.prototype.slice.call(stepRoot.querySelectorAll('[data-outfit-bundle-step]'));
    panels.sort(function (a, b) {
      return (
        parseInt(a.getAttribute('data-outfit-bundle-step') || '0', 10) -
        parseInt(b.getAttribute('data-outfit-bundle-step') || '0', 10)
      );
    });
    return panels;
  }

  function getOrderedBundleForms(stepRoot) {
    return getOrderedStepPanels(stepRoot)
      .map(function (panel) {
        return panel.querySelector('form[action*="/cart/add"]');
      })
      .filter(Boolean);
  }

  /** One product-step form by `data-outfit-bundle-step` index (avoids stale `forms[]` vs DOM). */
  function getBundleFormForProductStepIndex(scope, index) {
    if (!scope || index == null || index < 0) return null;
    var panel = scope.querySelector('[data-outfit-bundle-step="' + String(index) + '"]');
    return panel ? panel.querySelector('form[action*="/cart/add"]') : null;
  }

  function isFinishingStep(u, stateStep) {
    if (!u || !u.hasFinishingStep) return false;
    var step = stateStep != null ? stateStep : u.state && u.state.step;
    return step === u.finishingStepIndex;
  }

  function productIndexFromStateStep(u, stateStep) {
    if (!u) return null;
    var step = stateStep != null ? stateStep : u.state && u.state.step;
    var summaryAt = u.summaryAt != null ? u.summaryAt : u.n;
    if (step == null || step < 0 || step >= summaryAt) return null;
    if (isFinishingStep(u, step)) return null;
    if (u.hasFinishingStep && step > u.finishingStepIndex) return step - 1;
    return step;
  }

  function syncStepVisibility(stepRoot, stateStep, n, summaryAt, hasFinishingStep, finishingStepIndex) {
    var productIndex =
      hasFinishingStep && stateStep > finishingStepIndex ? stateStep - 1 : stateStep;
    getOrderedStepPanels(stepRoot).forEach(function (panel) {
      var i = parseInt(panel.getAttribute('data-outfit-bundle-step') || '0', 10);
      if (i >= n) return;
      var visible =
        stateStep < summaryAt &&
        (!hasFinishingStep || stateStep !== finishingStepIndex) &&
        i === productIndex;
      panel.classList.toggle('hidden', !visible);
    });
    var ftPanel = stepRoot.querySelector('[data-outfit-bundle-ft-step]');
    if (ftPanel) {
      var ftVisible = !!hasFinishingStep && stateStep === finishingStepIndex && stateStep < summaryAt;
      ftPanel.classList.toggle('hidden', !ftVisible);
    }
  }

  function clearBundleChromeTop(mountEl) {
    if (!mountEl) return;
    var top = mountEl.querySelector('[data-outfit-bundle-chrome-top]');
    var dyn = top ? top.querySelector('[data-ob-chrome-dynamic]') : null;
    var slot = mountEl.querySelector('[data-ob-summary-slot]');
    setChromeNotice(dyn, '');
    setStepLabel(top, '');
    setStepHint(top, '');
    hideSummarySlot(slot);
    var progress = top ? top.querySelector('[data-ob-progress]') : null;
    var fill = top ? top.querySelector('[data-ob-progress-fill]') : null;
    if (progress) {
      progress.setAttribute('hidden', '');
      progress.classList.add('hidden');
    }
    if (fill) fill.style.width = '0%';
  }

  function normalizeBundlePayload(parsed) {
    if (Array.isArray(parsed)) {
      return { items: parsed, finishingTouches: [] };
    }
    if (parsed && typeof parsed === 'object') {
      return {
        items: Array.isArray(parsed.items) ? parsed.items : [],
        finishingTouches: Array.isArray(parsed.finishingTouches) ? parsed.finishingTouches : [],
      };
    }
    return { items: [], finishingTouches: [] };
  }

  function mountOutfitBundleDom(mountEl, items, dialog, currencyCode, opts) {
    var persist = !!(opts && opts.persist);
    var finishingTouches = (opts && opts.finishingTouches) || [];
    var ftHeading = (opts && opts.ftHeading) || 'Finishing touches';
    var ftHint = (opts && opts.ftHint) || '';
    var bundleJsonId = opts && opts.jsonId ? String(opts.jsonId) : '';
    var chromeTop = mountEl.querySelector('[data-outfit-bundle-chrome-top]');
    var chromeBottom = mountEl.querySelector('[data-outfit-bundle-chrome-bottom]');
    if (!chromeTop || !chromeBottom) {
      mountEl.innerHTML = '<p class="text-sm text-muted">Bundle UI is not configured.</p>';
      return;
    }

    disconnectOutfitBundleDomObservers(mountEl);

    var chromeDynamic = chromeTop.querySelector('[data-ob-chrome-dynamic]');
    var summarySlot = mountEl.querySelector('[data-ob-summary-slot]');

    var stepRoot =
      mountEl.querySelector('[data-outfit-bundle-step-panels]') ||
      mountEl.querySelector('[data-outfit-bundle-steps-host]') ||
      mountEl;
    var forms = getOrderedBundleForms(stepRoot);
    var n = items && items.length ? items.length : forms.length;
    if (!forms.length || !n) {
      setChromeNotice(chromeDynamic, 'No products in this outfit.');
      hideSummarySlot(summarySlot);
      setStepLabel(chromeTop, '');
      setStepHint(chromeTop, '');
      chromeBottom.innerHTML = '';
      return;
    }

    tagOutfitBundleForms(mountEl);
    if (typeof window.__productCapsuleInitVariantPickers === 'function') {
      window.__productCapsuleInitVariantPickers(mountEl);
    }

    var hasFinishingStep = finishingTouches.length > 0;
    var firstMixinIndex = items.findIndex(function (item) {
      return !!(item && item.is_mixin);
    });
    var finishingStepIndex = hasFinishingStep
      ? firstMixinIndex >= 0
        ? firstMixinIndex
        : n
      : -1;
    var summaryAt = n + (hasFinishingStep ? 1 : 0);
    var wizardSteps = summaryAt;

    var state = {
      step: 0,
      /** Finishing extras: product id -> { wants: true, variantId: string|null }. variantId required when wants && requires sizes. */
      finishingByProductId: {},
      /** Step indices (product steps only) the shopper chose to skip because nothing was in stock. */
      skippedSteps: {},
    };
    /** Tracks wizard step across renders so we only scroll the body when the step index changes. */
    var lastRenderedStepForScroll = state.step;

    function setChromeBtnHidden(el, hidden) {
      if (!el) return;
      if (hidden) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      }
    }
    var uiRef = {
      state: state,
      n: n,
      summaryAt: summaryAt,
      hasFinishingStep: hasFinishingStep,
      finishingStepIndex: finishingStepIndex,
      wizardSteps: wizardSteps,
      forms: forms,
      chromeTop: chromeTop,
      chromeBottom: chromeBottom,
      items: items,
      finishingTouches: finishingTouches,
      ftHeading: ftHeading,
      ftHint: ftHint,
    };
    stepRoot._outfitBundleUiRef = uiRef;

    function ftProductKey(ft) {
      if (!ft) return '';
      if (ft.product_id != null && String(ft.product_id) !== '') return String(ft.product_id);
      return 'v:' + String(ft.variant_id != null ? ft.variant_id : '');
    }

    function ftForProductId(pid) {
      var s = String(pid);
      return (finishingTouches || []).find(function (ft) {
        return ft && ftProductKey(ft) === s;
      });
    }

    function ftRequiresSizes(ft) {
      return !!ft && !!ft.requires_variant_selection;
    }

    function ftVariantById(ft, vid) {
      if (!ft || vid == null || vid === '') return null;
      var key = String(vid).trim();
      if (!key) return null;
      if (Array.isArray(ft.variants) && ft.variants.length) {
        var found =
          ft.variants.find(function (v) {
            return String(v.id) === key;
          }) || null;
        if (found) return found;
      }
      if (String(ft.variant_id) === key) {
        return {
          id: ft.variant_id,
          title: ft.variant_title,
          available: ft.available !== false,
          price_cents: ft.price_cents,
          price_display: ft.price_display,
        };
      }
      return null;
    }

    function getFinishingFormForProduct(pid) {
      var row = stepRoot.querySelector('[data-ob-ft-row][data-ob-ft-product-id="' + String(pid) + '"]');
      if (!row) return null;
      return row.querySelector('form[action*="/cart/add"]');
    }

    function readFinishingVariantFromDom(pid) {
      return getVariantIdFromBundleForm(getFinishingFormForProduct(pid));
    }

    function syncFinishingVariantIdsFromDom() {
      stepRoot.querySelectorAll('[data-ob-ft-row]').forEach(function (rowEl) {
        var pid = rowEl.getAttribute('data-ob-ft-product-id');
        if (!pid) return;
        var ft = ftForProductId(pid);
        if (!ft || !ftRequiresSizes(ft)) return;
        var by = state.finishingByProductId || {};
        var st = by[pid];
        if (!st || !st.wants) return;
        var vid = readFinishingVariantFromDom(pid);
        st.variantId = vid && vid !== '' ? vid : null;
      });
    }

    function variantForProductStep(stepIndex, vid) {
      var p = items[stepIndex];
      if (!p || !p.variants || vid == null) return null;
      var key = String(vid).trim();
      if (!key) return null;
      var found =
        p.variants.find(function (x) {
          return String(x.id) === key;
        }) || null;
      if (found) return found;
      var nk = Number(key);
      if (!Number.isFinite(nk)) return null;
      return (
        p.variants.find(function (x) {
          return Number(x.id) === nk;
        }) || null
      );
    }

    function isSelectionInvalid(u) {
      if (!u) return true;
      var summaryAt = u.summaryAt != null ? u.summaryAt : u.n;
      if (u.state.step >= summaryAt) return true;
      if (isFinishingStep(u)) {
        syncFinishingVariantIdsFromDom();
        var fts = u.finishingTouches || [];
        var by = u.state.finishingByProductId || {};
        for (var fj = 0; fj < fts.length; fj++) {
          var fte = fts[fj];
          if (!fte) continue;
          var pid = ftProductKey(fte);
          if (!pid) continue;
          var st = by[pid];
          if (!st || !st.wants) continue;
          var vidPick = null;
          if (ftRequiresSizes(fte)) vidPick = readFinishingVariantFromDom(pid);
          else vidPick = st.variantId || fte.default_variant_id || fte.variant_id;
          if (!vidPick || vidPick === '') return true;
          var fv = ftVariantById(fte, vidPick);
          if (!fv || fv.available === false) return true;
        }
        return false;
      }
      var stepIdx = productIndexFromStateStep(u);
      if (stepIdx == null || stepIdx >= u.n) return true;
      if (u.state.skippedSteps && u.state.skippedSteps[String(stepIdx)]) return false;
      var stepForm = getBundleFormForProductStepIndex(stepRoot, stepIdx);
      var id = getVariantIdFromBundleForm(stepForm);
      if (id == null || id === '') return true;
      var v = variantForProductStep(stepIdx, id);
      return !v || v.available === false;
    }

    function isFinishingSelectionInvalid(u) {
      syncFinishingVariantIdsFromDom();
      var fts = (u && u.finishingTouches) || [];
      var by = (u && u.state && u.state.finishingByProductId) || {};
      for (var fi = 0; fi < fts.length; fi++) {
        var ft = fts[fi];
        if (!ft) continue;
        var pid = ftProductKey(ft);
        var st = by[pid];
        if (!st || !st.wants) continue;
        var vidPick = null;
        if (ftRequiresSizes(ft)) vidPick = readFinishingVariantFromDom(pid);
        else vidPick = st.variantId || ft.default_variant_id || ft.variant_id;
        if (!vidPick || vidPick === '') return true;
        var v = ftVariantById(ft, vidPick);
        if (!v || v.available === false) return true;
      }
      return false;
    }

    function isSummarySelectionInvalid(u) {
      if (!u || !u.forms || !u.items) return true;
      var skipMap = (u.state && u.state.skippedSteps) || {};
      for (var i = 0; i < u.n; i++) {
        if (skipMap[String(i)]) continue;
        var sumForm = getBundleFormForProductStepIndex(stepRoot, i);
        var id = getVariantIdFromBundleForm(sumForm);
        if (id == null || id === '') return true;
        var v = variantForProductStep(i, id);
        if (!v || v.available === false) return true;
      }
      if (isFinishingSelectionInvalid(u)) return true;
      return false;
    }

    function syncNextFromRef(u) {
      if (!u) return;
      var summaryAtRef = u.summaryAt != null ? u.summaryAt : u.n;
      if (u.state.step >= summaryAtRef) return;
      var nextBtn = u.chromeBottom && u.chromeBottom.querySelector('[data-ob-next]');
      if (!nextBtn) return;
      var disabled = isSelectionInvalid(u);
      nextBtn.disabled = disabled;
      nextBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateNextButtonDisabled() {
      syncNextFromRef(uiRef);
    }

    function syncAddFromRef(u) {
      if (!u) return;
      var summaryAtRef = u.summaryAt != null ? u.summaryAt : u.n;
      if (u.state.step < summaryAtRef) return;
      var addBtn = u.chromeBottom && u.chromeBottom.querySelector('[data-ob-add]');
      if (!addBtn) return;
      var disabled = isSummarySelectionInvalid(u);
      addBtn.disabled = disabled;
      addBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateAddButtonDisabled() {
      syncAddFromRef(uiRef);
    }

    /** Must read `u` from `stepRoot._outfitBundleUiRef` when called from the variant delegate (persist re-mounts replace state but keep one delegate listener). */
    function syncBundleChromeBottomFromRef(u) {
      if (!u || !u.chromeBottom || !u.state) return;
      var summaryAtRef = u.summaryAt != null ? u.summaryAt : u.n;
      var isSummary = u.state.step >= summaryAtRef;
      var bottom = u.chromeBottom;
      var nextBtn = bottom.querySelector('[data-ob-next]');
      var backBtn = bottom.querySelector('[data-ob-back]');
      var addBtn = bottom.querySelector('[data-ob-add]');
      var skipBtn = bottom.querySelector('[data-ob-skip]');
      setChromeBtnHidden(nextBtn, isSummary);
      setChromeBtnHidden(backBtn, u.state.step <= 0);
      setChromeBtnHidden(addBtn, !isSummary);
      var onFinishing = isFinishingStep(u);
      var showSkip = !isSummary && !onFinishing;
      setChromeBtnHidden(skipBtn, !showSkip);
    }

    /** Every `mountOutfitBundleDom` run must bind fresh listeners: the old `syncFromRoot` closed over stale `items` / validators if we only attached once (persist PDP re-opens). */
    try {
      delete stepRoot.dataset.outfitBundleVariantDelegate;
    } catch (_delErr) {}
    if (mountEl._outfitBundleVariantSyncAbort && typeof mountEl._outfitBundleVariantSyncAbort.abort === 'function') {
      try {
        mountEl._outfitBundleVariantSyncAbort.abort();
      } catch (_abortErr) {}
    }
    var variantSyncAbort = new AbortController();
    mountEl._outfitBundleVariantSyncAbort = variantSyncAbort;
    var vsOpts = { capture: true, signal: variantSyncAbort.signal };

    var outfitBundleDebugLogUntil = 0;

    var syncFromRoot = function () {
      var u = stepRoot._outfitBundleUiRef;
      if (u) {
        u.forms = getOrderedBundleForms(stepRoot);
      }
      if (u && u.state && u.state.skippedSteps) {
        var st = u.state.step;
        var productIndex = productIndexFromStateStep(u, st);
        if (productIndex != null && productIndex >= 0 && productIndex < u.n) {
          var skipForm = getBundleFormForProductStepIndex(stepRoot, productIndex);
          var sid = getVariantIdFromBundleForm(skipForm);
          if (sid != null && sid !== '') {
            var vv = variantForProductStep(productIndex, sid);
            if (vv && vv.available !== false) delete u.state.skippedSteps[String(productIndex)];
          }
        }
      }
      syncFinishingVariantIdsFromDom();
      syncNextFromRef(u);
      syncAddFromRef(u);
      syncBundleChromeBottomFromRef(u);
      logOutfitBundleDebugIfNeeded(u);
    };
    /** Immediate read + deferred pass for late layout / iOS. */
    var scheduleSyncFromRoot = function () {
      syncFromRoot();
      requestAnimationFrame(function () {
        requestAnimationFrame(syncFromRoot);
      });
    };
    mountEl.addEventListener('change', scheduleSyncFromRoot, vsOpts);
    mountEl.addEventListener('input', scheduleSyncFromRoot, vsOpts);
    mountEl.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (!t.closest('[data-pdp-variant-selection-target]')) return;
        window.setTimeout(syncFromRoot, 0);
      },
      vsOpts,
    );

    var obMoRaf = null;
    var domObserver = new MutationObserver(function () {
      if (obMoRaf != null) return;
      obMoRaf = requestAnimationFrame(function () {
        obMoRaf = null;
        syncFromRoot();
      });
    });
    try {
      domObserver.observe(mountEl, {
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'value', 'disabled'],
      });
      mountEl._outfitBundleDomObserver = domObserver;
    } catch (_moErr) {}

    function logOutfitBundleDebugIfNeeded(u) {
      if (!isOutfitBundleDebugEnabled() || !u || !u.state) return;
      var summaryAtRef = u.summaryAt != null ? u.summaryAt : u.n;
      if (u.state.step >= summaryAtRef) return;
      if (isFinishingStep(u)) return;
      var stepIdx = productIndexFromStateStep(u);
      if (stepIdx == null || stepIdx >= u.n) return;
      if (u.state.skippedSteps && u.state.skippedSteps[String(stepIdx)]) return;
      var nextBtn = u.chromeBottom && u.chromeBottom.querySelector('[data-ob-next]');
      if (!nextBtn || !nextBtn.disabled) return;
      var nowMs = Date.now();
      if (nowMs < outfitBundleDebugLogUntil) return;
      outfitBundleDebugLogUntil = nowMs + 2500;
      var f = getBundleFormForProductStepIndex(stepRoot, stepIdx);
      var id = getVariantIdFromBundleForm(f);
      var v = id != null && id !== '' ? variantForProductStep(stepIdx, id) : null;
      var p = u.items && u.items[stepIdx];
      var jsonIds =
        p && p.variants
          ? p.variants.slice(0, 8).map(function (x) {
              return String(x.id);
            })
          : [];
      console.warn('[outfit-bundle] Next disabled on product step', {
        dialogOpen: !!(dialog && dialog.open),
        stateStep: u.state.step,
        productStepIndex: stepIdx,
        productTitle: p && p.title,
        domVariantId: id,
        jsonVariantCount: p && p.variants ? p.variants.length : 0,
        sampleJsonVariantIds: jsonIds,
        matchedVariant: !!v,
        matchedAvailable: v ? v.available : null,
        bundleFormFound: !!f,
      });
    }

    function variantTitleForIndex(i, vid) {
      var p = items[i];
      if (!p || !p.variants || vid == null) return '—';
      var key = String(vid).trim();
      var v = p.variants.find(function (x) {
        return String(x.id) === key;
      });
      if (!v || !v.title) return '—';
      var line = variantLineLabelForUi(v.title);
      return line;
    }

    function picksFromForms() {
      var out = [];
      for (var pi = 0; pi < n; pi++) {
        out.push(getVariantIdFromBundleForm(getBundleFormForProductStepIndex(stepRoot, pi)));
      }
      return out;
    }

    function computeBundleTotalCents() {
      var picks = picksFromForms();
      var total = 0;
      var skipMap = state.skippedSteps || {};
      for (var i = 0; i < n; i++) {
        if (skipMap[String(i)]) continue;
        var vid = picks[i];
        var v = variantForProductStep(i, vid);
        if (v && typeof v.price_cents === 'number') total += v.price_cents;
      }
      (finishingTouches || []).forEach(function (ft) {
        if (!ft) return;
        var pid = ftProductKey(ft);
        var st = (state.finishingByProductId || {})[pid];
        if (!st || !st.wants) return;
        var vid = null;
        if (ftRequiresSizes(ft)) vid = readFinishingVariantFromDom(pid);
        else vid = st.variantId || ft.default_variant_id || ft.variant_id;
        if (!vid) return;
        var v = ftVariantById(ft, vid);
        if (v && typeof v.price_cents === 'number') total += v.price_cents;
      });
      return total;
    }

    function pruneFinishingSelection() {
      syncFinishingVariantIdsFromDom();
      var by = state.finishingByProductId || {};
      Object.keys(by).forEach(function (pid) {
        var st = by[pid];
        if (!st || !st.wants) {
          delete by[pid];
          return;
        }
        var ft = ftForProductId(pid);
        if (!ft) {
          delete by[pid];
          return;
        }
        var vid = null;
        if (ftRequiresSizes(ft)) vid = readFinishingVariantFromDom(pid);
        else vid = st.variantId || ft.default_variant_id || ft.variant_id;
        if (!vid) {
          delete by[pid];
          return;
        }
        var v = ftVariantById(ft, vid);
        if (!v || v.available === false) delete by[pid];
      });
    }

    function render() {
      forms = getOrderedBundleForms(stepRoot);
      uiRef.state = state;
      uiRef.n = n;
      uiRef.summaryAt = summaryAt;
      uiRef.hasFinishingStep = hasFinishingStep;
      uiRef.finishingStepIndex = finishingStepIndex;
      uiRef.wizardSteps = wizardSteps;
      uiRef.forms = forms;
      uiRef.chromeTop = chromeTop;
      uiRef.chromeBottom = chromeBottom;
      uiRef.items = items;
      uiRef.finishingTouches = finishingTouches;
      uiRef.ftHeading = ftHeading;
      uiRef.ftHint = ftHint;
      stepRoot._outfitBundleUiRef = uiRef;
      stepRoot._outfitBundleRender = render;
      var totalSteps = summaryAt + 1;
      var pct = Math.round(((state.step + 1) / totalSteps) * 100);
      var isSummary = state.step >= summaryAt;
      var onFinishing = isFinishingStep(uiRef);
      var productStepIndex = productIndexFromStateStep(uiRef);
      var stepsRegion =
        mountEl.querySelector('[data-outfit-bundle-steps-host]') ||
        mountEl.querySelector('[data-outfit-bundle-step-panels]');
      if (stepsRegion) {
        if (isSummary) {
          stepsRegion.setAttribute('hidden', '');
          stepsRegion.classList.add('hidden');
        } else {
          stepsRegion.removeAttribute('hidden');
          stepsRegion.classList.remove('hidden');
        }
      }
      var scrollArea = mountEl.querySelector('[data-outfit-bundle-scroll]');
      if (scrollArea) {
        if (isSummary) scrollArea.setAttribute('data-bundle-scroll', 'summary');
        else if (onFinishing) {
          scrollArea.setAttribute('data-bundle-scroll', 'finishing');
        }
        else scrollArea.setAttribute('data-bundle-scroll', 'steps');
      }
      setChromeNotice(chromeDynamic, '');
      setProgress(chromeTop, pct);

      var nextBtn = chromeBottom.querySelector('[data-ob-next]');
      var btns = chromeBottom.querySelector('[data-outfit-bundle-chrome-buttons]');
      if (nextBtn && btns) {
        var np = btns.getAttribute('data-ob-label-next-piece') || '';
        var nr = btns.getAttribute('data-ob-label-next-review') || '';
        if (!isSummary && state.step === summaryAt - 1 && nr) nextBtn.textContent = nr;
        else if (!isSummary && np) nextBtn.textContent = np;
      }

      if (!isSummary) {
        hideSummarySlot(summarySlot);
        if (onFinishing) {
          setStepHint(chromeTop, '');
          setStepLabel(
            chromeTop,
            'Step ' +
              (state.step + 1) +
              ' of ' +
              wizardSteps +
              ' — ' +
              (ftHeading || 'Finishing touches')
          );
        } else {
          var p = productStepIndex != null ? items[productStepIndex] : null;
          var mixinCopy = readMixinChromeStrings(chromeTop);
          var label;
          var hint = '';
          if (p && p.is_mixin) {
            var mixinNum = mixinOrdinalAmongSteps(items, productStepIndex);
            label = mixinCopy.prefix + (mixinNum > 0 ? ' ' + mixinNum : '');
            hint = mixinCopy.hint;
          } else {
            label =
              'Step ' +
              (state.step + 1) +
              ' of ' +
              wizardSteps +
              ' — ' +
              (p && p.title ? p.title : '');
          }
          setStepLabel(chromeTop, label);
          setStepHint(chromeTop, hint);
        }
        syncStepVisibility(
          stepRoot,
          state.step,
          n,
          summaryAt,
          hasFinishingStep,
          finishingStepIndex
        );
        stepRoot.querySelectorAll('[data-ob-ft-row]').forEach(function (rowEl) {
          var pid = rowEl.getAttribute('data-ob-ft-product-id');
          if (!pid) return;
          var wantsEl = rowEl.querySelector('[data-ob-ft-wants]');
          var panel = rowEl.querySelector('[data-ob-ft-variant-panel]');
          var req = (rowEl.getAttribute('data-ob-ft-requires-sizes') || '') === 'true';
          var st = (state.finishingByProductId || {})[pid];
          var wants = !!(st && st.wants);
          if (wantsEl) wantsEl.checked = wants;
          if (panel) {
            if (req) {
              if (wants) {
                panel.removeAttribute('hidden');
                panel.classList.remove('hidden');
              } else {
                panel.setAttribute('hidden', '');
                panel.classList.add('hidden');
              }
            }
          }
          var priceEl = rowEl.querySelector('[data-ob-ft-row-price]');
          var ft = ftForProductId(pid);
          if (priceEl && ft) {
            var vid = null;
            if (ftRequiresSizes(ft)) vid = readFinishingVariantFromDom(pid);
            else vid = (st && st.variantId) || ft.default_variant_id || ft.variant_id;
            var v = ftVariantById(ft, vid);
            if (v && v.price_display) priceEl.textContent = v.price_display;
            else if (ft.price_display) priceEl.textContent = ft.price_display;
          }
        });
      } else {
        setStepHint(chromeTop, '');
        setStepLabel(
          chromeTop,
          chromeTop.getAttribute('data-ob-label-review-outfit') || 'Review your outfit'
        );
        pruneFinishingSelection();
        syncStepVisibility(
          stepRoot,
          state.step,
          n,
          summaryAt,
          hasFinishingStep,
          finishingStepIndex
        );
        if (summarySlot && bundleJsonId) {
          var src = document.getElementById('outfit-bundle-summary-root-' + bundleJsonId);
          var needClone =
            summarySlot.getAttribute('data-ob-summary-json') !== bundleJsonId ||
            !summarySlot.querySelector('[data-outfit-bundle-summary-markup]');
          if (needClone && src) {
            var inner = src.querySelector('[data-outfit-bundle-summary-markup]');
            if (inner) {
              summarySlot.innerHTML = '';
              summarySlot.appendChild(inner.cloneNode(true));
              summarySlot.setAttribute('data-ob-summary-json', bundleJsonId);
            }
          }
          summarySlot.removeAttribute('hidden');
          summarySlot.classList.remove('hidden');
          var root = summarySlot.querySelector('[data-outfit-bundle-summary-markup]');
          if (root) {
            var picks = picksFromForms();
            var totalCents = computeBundleTotalCents();
            var skipMap = state.skippedSteps || {};
            items.forEach(function (p, i) {
              var vid = picks[i];
              var row = root.querySelector('[data-ob-summary-row][data-line="' + i + '"]');
              if (!row) return;
              var skipped = !!skipMap[String(i)];
              row.hidden = skipped;
              if (skipped) return;
              var vEl = row.querySelector('[data-ob-summary-variant]');
              var pEl = row.querySelector('[data-ob-summary-price]');
              var v = variantForProductStep(i, vid);
              if (vEl) {
                var sumVt = variantTitleForIndex(i, vid);
                vEl.textContent = sumVt;
                var vWrap = vEl.closest('p');
                if (vWrap) vWrap.classList.toggle('hidden', sumVt === '');
              }
              if (pEl) pEl.textContent = v && v.price_display ? v.price_display : '—';
            });
            var totalEl = root.querySelector('[data-ob-summary-total]');
            if (totalEl) totalEl.textContent = formatMoney(totalCents, currencyCode);
            var ftRows = root.querySelector('[data-ob-summary-ft-rows]');
            if (ftRows) {
              ftRows.innerHTML = '';
              (finishingTouches || []).forEach(function (ft) {
                if (!ft) return;
                var pid = ftProductKey(ft);
                var st = (state.finishingByProductId || {})[pid];
                if (!st || !st.wants) return;
                var sumVid = null;
                if (ftRequiresSizes(ft)) sumVid = readFinishingVariantFromDom(pid);
                else sumVid = st.variantId || ft.default_variant_id || ft.variant_id;
                var sumV = ftVariantById(ft, sumVid);
                if (!sumV) return;
                var row = document.createElement('div');
                row.className = 'flex gap-3 py-3';
                var imgWrap = document.createElement('div');
                imgWrap.className =
                  'aspect-[2/3] w-32 shrink-0 overflow-hidden border bg-neutral-200';
                if (ft.featured_image) {
                  var img = document.createElement('img');
                  img.src = ft.featured_image;
                  img.alt = '';
                  img.className = 'size-full object-cover';
                  img.width = 128;
                  img.height = 192;
                  img.loading = 'lazy';
                  imgWrap.appendChild(img);
                } else {
                  imgWrap.className +=
                    ' flex items-center justify-center font-sans text-[7px] text-muted';
                  imgWrap.textContent = '—';
                }
                var body = document.createElement('div');
                body.className = 'flex min-w-0 flex-1 flex-col gap-2';
                var titleRow = document.createElement('div');
                titleRow.className = 'flex items-baseline justify-between gap-3';
                var titleP = document.createElement('p');
                titleP.className = 'font-headline leading-none';
                titleP.textContent = ft.title || '';
                var priceSpan = document.createElement('span');
                priceSpan.className = 'font-headline leading-none';
                priceSpan.textContent = (sumV && sumV.price_display) || ft.price_display || '—';
                titleRow.appendChild(titleP);
                titleRow.appendChild(priceSpan);
                var vtRaw = (sumV && sumV.title) || ft.variant_title;
                var vt = variantLineLabelForUi(vtRaw);
                body.appendChild(titleRow);
                if (vt) {
                  var varP = document.createElement('p');
                  varP.className = 'leading-none text-sm text-muted';
                  varP.textContent = vt;
                  body.appendChild(varP);
                }
                row.appendChild(imgWrap);
                row.appendChild(body);
                ftRows.appendChild(row);
              });
            }
          }
          if (!summarySlot.querySelector('[data-outfit-bundle-summary-markup]')) {
            summarySlot.setAttribute('hidden', '');
            summarySlot.classList.add('hidden');
          }
        } else {
          hideSummarySlot(summarySlot);
          setChromeNotice(chromeDynamic, 'Bundle summary is not configured.');
        }
      }

      syncBundleChromeBottomFromRef(uiRef);

      updateNextButtonDisabled();
      updateAddButtonDisabled();

      var stepped = lastRenderedStepForScroll !== state.step;
      if (stepped) {
        var scrollEl = mountEl.querySelector('[data-outfit-bundle-scroll]');
        if (scrollEl) scrollEl.scrollTop = 0;
      }
      lastRenderedStepForScroll = state.step;
    }

    if (!mountEl.dataset.obFtDelegated) {
      mountEl.dataset.obFtDelegated = '1';
      mountEl.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        var u = stepRoot._outfitBundleUiRef;
        if (!u || !u.state) return;
        if (t.matches('input[data-ob-ft-wants]')) {
          var rowEl = t.closest('[data-ob-ft-row]');
          if (!rowEl) return;
          var pid = rowEl.getAttribute('data-ob-ft-product-id');
          if (!pid) return;
          var ft = ftForProductId(pid);
          if (!ft) return;
          if (t.checked) {
            if (ftRequiresSizes(ft)) {
              u.state.finishingByProductId[pid] = {
                wants: true,
                variantId: readFinishingVariantFromDom(pid),
              };
            } else {
              var def =
                t.getAttribute('data-ob-ft-default-variant-id') ||
                ft.default_variant_id ||
                ft.variant_id;
              u.state.finishingByProductId[pid] = {
                wants: true,
                variantId: def != null ? String(def) : null,
              };
            }
          } else {
            delete u.state.finishingByProductId[pid];
          }
          var r = stepRoot._outfitBundleRender;
          if (typeof r === 'function') r();
          return;
        }
      });
    }

    var prevChromeCb = chromeBottom._outfitBundleChromeClick;
    if (prevChromeCb) chromeBottom.removeEventListener('click', prevChromeCb);
    var onChromeBottomClick = function (e) {
      if (e.target.closest('[data-ob-back]')) {
        state.step = Math.max(0, state.step - 1);
        render();
        return;
      }
      if (e.target.closest('[data-ob-next]')) {
        if (isSelectionInvalid(uiRef)) return;
        state.step += 1;
        render();
        return;
      }
      if (e.target.closest('[data-ob-skip]')) {
        if (state.step >= summaryAt) return;
        if (isFinishingStep(uiRef)) return;
        var skipProductIndex = productIndexFromStateStep(uiRef);
        if (skipProductIndex == null) return;
        state.skippedSteps[String(skipProductIndex)] = true;
        state.step += 1;
        render();
        return;
      }
      var addBtn = e.target.closest('[data-ob-add]');
      if (!addBtn) return;
      var picks = picksFromForms();
      var skipMap = state.skippedSteps || {};
      for (var bi = 0; bi < n; bi++) {
        if (skipMap[String(bi)]) continue;
        if (picks[bi] == null || picks[bi] === '') {
          alert('Please choose a variant for each piece.');
          return;
        }
      }
      var badAvail = false;
      for (var bj = 0; bj < n; bj++) {
        if (skipMap[String(bj)]) continue;
        var vid0 = picks[bj];
        var v0 = variantForProductStep(bj, vid0);
        if (!v0 || v0.available === false) {
          badAvail = true;
          break;
        }
      }
      if (badAvail) {
        alert('One or more selected variants are unavailable. Adjust your choices before adding to bag.');
        return;
      }
      var lineItems = [];
      for (var bk = 0; bk < n; bk++) {
        if (skipMap[String(bk)]) continue;
        var cartId = variantIdForCart(picks[bk]);
        if (cartId == null) continue;
        lineItems.push({ id: cartId, quantity: 1 });
      }
      var chromeBtnsEl = chromeBottom.querySelector('[data-outfit-bundle-chrome-buttons]');
      var emptyBagMsg =
        (chromeBtnsEl && chromeBtnsEl.getAttribute('data-ob-alert-no-items')) ||
        'Choose at least one piece to add to your bag.';
      if (!lineItems.length) {
        alert(emptyBagMsg);
        return;
      }
      addBtn.disabled = true;
      (finishingTouches || []).forEach(function (ft) {
        if (!ft) return;
        var pid = ftProductKey(ft);
        var st = (state.finishingByProductId || {})[pid];
        if (!st || !st.wants) return;
        var addVid = null;
        if (ftRequiresSizes(ft)) addVid = readFinishingVariantFromDom(pid);
        else addVid = st.variantId || ft.default_variant_id || ft.variant_id;
        if (!addVid) return;
        var ftCartId = variantIdForCart(addVid);
        if (ftCartId != null) lineItems.push({ id: ftCartId, quantity: 1 });
      });
      var payload = { items: lineItems };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (res.ok) {
            if (window.__closeUiDialogSheet && dialog) window.__closeUiDialogSheet(dialog);
            var p = Promise.resolve();
            if (window.__cartDrawerRefresh) p = window.__cartDrawerRefresh();
            p.then(function () {
              if (window.__openCartDrawer) window.__openCartDrawer(addBtn);
              else window.location.href = '/cart';
            });
            return;
          }
          var msg =
            res.data && (res.data.description || res.data.message)
              ? res.data.description || res.data.message
              : 'Could not add to bag.';
          alert(msg);
          addBtn.disabled = false;
        })
        .catch(function () {
          alert('Could not add to bag. Try again.');
          addBtn.disabled = false;
        });
    };
    chromeBottom.addEventListener('click', onChromeBottomClick);
    chromeBottom._outfitBundleChromeClick = onChromeBottomClick;

    render();
    var initScrollEl = mountEl.querySelector('[data-outfit-bundle-scroll]');
    if (initScrollEl) initScrollEl.scrollTop = 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-outfit-bundle-open]');
    if (!btn) return;
    var jsonId = btn.getAttribute('data-outfit-bundle-json');
    var dialogId = btn.getAttribute('data-outfit-bundle-dialog');
    if (!jsonId || !dialogId) return;
    var script = document.getElementById(jsonId);
    var dialog = document.getElementById(dialogId);
    if (!script || !dialog) return;
    var currency = script.getAttribute('data-currency') || 'USD';
    var ftHeading = script.getAttribute('data-ob-ft-heading') || '';
    var ftHint = script.getAttribute('data-ob-ft-hint') || '';
    var parsed;
    var items;
    var finishingTouches;
    try {
      parsed = JSON.parse(script.textContent || 'null');
    } catch (err) {
      return;
    }
    var norm = normalizeBundlePayload(parsed);
    items = norm.items;
    finishingTouches = norm.finishingTouches;
    var mountEl = dialog.querySelector('[data-outfit-bundle-mount]');
    if (!mountEl) return;

    var persist = mountEl.hasAttribute('data-outfit-bundle-persist');
    var stepsHost = mountEl.querySelector('[data-outfit-bundle-steps-host]');
    var tplKey = btn.getAttribute('data-outfit-bundle-steps-template');
    if (!persist && stepsHost && tplKey) {
      stepsHost.innerHTML = '';
      var tpl = document.getElementById('outfit-bundle-steps-' + tplKey);
      if (tpl && tpl.content) stepsHost.appendChild(tpl.content.cloneNode(true));
    }

    mountOutfitBundleDom(mountEl, items, dialog, currency, {
      persist: persist,
      finishingTouches: finishingTouches,
      ftHeading: ftHeading,
      ftHint: ftHint,
      jsonId: jsonId,
    });
    openDialog(dialog);
  });

  document.addEventListener(
    'ui-dialog-sheet:closed',
    function (e) {
      var d = e.detail && e.detail.dialog;
      if (!d) return;
      var m = d.querySelector('[data-outfit-bundle-mount]');
      if (!m) return;
      disconnectOutfitBundleDomObservers(m);
      if (m.hasAttribute('data-outfit-bundle-persist')) {
        var top = m.querySelector('[data-outfit-bundle-chrome-top]');
        var bottom = m.querySelector('[data-outfit-bundle-chrome-bottom]');
        clearBundleChromeTop(m);
        if (bottom && !bottom.querySelector('[data-outfit-bundle-chrome-buttons]')) bottom.innerHTML = '';
        m.querySelectorAll('[data-outfit-bundle-step]').forEach(function (el) {
          var i = parseInt(el.getAttribute('data-outfit-bundle-step') || '0', 10);
          if (i === 0) el.classList.remove('hidden');
          else el.classList.add('hidden');
        });
        var ftPanelPersist = m.querySelector('[data-outfit-bundle-ft-step]');
        if (ftPanelPersist) ftPanelPersist.classList.add('hidden');
        return;
      }
      var host = m.querySelector('[data-outfit-bundle-steps-host]');
      if (host) host.innerHTML = '';
      var topEl = m.querySelector('[data-outfit-bundle-chrome-top]');
      var bottomEl = m.querySelector('[data-outfit-bundle-chrome-bottom]');
      clearBundleChromeTop(m);
      if (bottomEl && !bottomEl.querySelector('[data-outfit-bundle-chrome-buttons]')) bottomEl.innerHTML = '';
    },
    true
  );
})();
